export let language = '';

export const setLanguage = (lang) => {
    language = lang;
};
